var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusthis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 159C134.899 159 164 129.899 164 94C164 58.1015 134.899 29 99 29C63.1015 29 34 58.1015 34 94C34 129.899 63.1015 159 99 159Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 51.3268H165.187V124.253C165.187 130.613 160.027 135.773 153.667 135.773H44.4268C39.0401 135.773 34.6667 131.4 34.6667 126.013V51.3335V51.3268Z",
    fill: "white",
    stroke: "#3D5199",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2201 40H157.56C161.773 40 165.187 43.42 165.187 47.6267V51.3267H34.6667V49.5533C34.6667 44.28 38.9467 40 44.2201 40Z",
    fill: "#36A635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 40H44.3534C39.0036 40 34.6667 44.3369 34.6667 49.6867V126.087C34.6667 131.436 39.0036 135.773 44.3534 135.773H155.5C160.85 135.773 165.187 131.436 165.187 126.087V49.6867C165.187 44.3369 160.85 40 155.5 40Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 51.3268H165.187",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1001 47.9733C44.3777 47.9733 45.4134 46.9376 45.4134 45.66C45.4134 44.3824 44.3777 43.3467 43.1001 43.3467C41.8225 43.3467 40.7866 44.3824 40.7866 45.66C40.7866 46.9376 41.8225 47.9733 43.1001 47.9733Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2799 47.9733C52.5575 47.9733 53.5934 46.9376 53.5934 45.66C53.5934 44.3824 52.5575 43.3467 51.2799 43.3467C50.0023 43.3467 48.9666 44.3824 48.9666 45.66C48.9666 46.9376 50.0023 47.9733 51.2799 47.9733Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.46 47.9733C60.7376 47.9733 61.7735 46.9376 61.7735 45.66C61.7735 44.3824 60.7376 43.3467 59.46 43.3467C58.1824 43.3467 57.1467 44.3824 57.1467 45.66C57.1467 46.9376 58.1824 47.9733 59.46 47.9733Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.6 63.9534V68.6468",
    stroke: "#36A635",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112.6 73.3333V78.02",
    stroke: "#36A635",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.26 70.9867H105.567",
    stroke: "#36A635",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.633 70.9867H114.947",
    stroke: "#36A635",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.34 58.6068H46.52C43.9427 58.6068 41.8533 60.6961 41.8533 63.2734V123.827C41.8533 126.404 43.9427 128.493 46.52 128.493H153.34C155.917 128.493 158.007 126.404 158.007 123.827V63.2734C158.007 60.6961 155.917 58.6068 153.34 58.6068Z",
    fill: "#ECEEF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.86 69L138.713 83.86V165.573H70V69H123.86Z",
    fill: "#AEAEAE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.447 63.1133L133.3 77.9733V159.687H64.5869V63.1133H118.447Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.3 153.76V159.687H64.5867V102.113",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5867 102.113V63.1133H118.447L133.3 77.9733V108.067",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.52 82.0666H113.233V72.7799",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.72 99.8402H117.173",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.72 110.627H117.173",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.72 121.413H104.307",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M139.653 137.84V129.033H146.113L133.3 114.627L120.493 129.033H126.9V137.84H139.653Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.127 142.753H139.533",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.1 148.153H139.507",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusthis);
export default __webpack_public_path__ + "static/media/plusthis.2da95567dc6a93ae64e9ae564a1458cf.svg";
export { ForwardRef as ReactComponent };